import api from './api';

/**
 * Mijn Cockpit → Profiel → Facturen (Onderdeel 56E). Server:
 * src/routes/professionalFacturen.ts; Stripe-status en dashboardlink via de
 * bestaande /professional/stripe/*-routes.
 */

const BASIS = '/v1/professional/fiscaal';

export type RolStatus = '21_percent' | '0_percent_medical';
export type BtwBehandeling = RolStatus | '0_percent_kor';

export interface ActieveRol {
  professional_type: string;
  label: string;
  status: RolStatus;
  medisch_mogelijk: boolean;
  medisch_geverifieerd: boolean;
}

export interface BtwInstellingen {
  kor_actief: boolean;
  kor_sinds: string | null;
  rollen: ActieveRol[];
  omzet_dit_jaar: number;
}

export interface Wallet {
  onboarding_status: 'not_started' | 'pending' | 'verified' | 'rejected';
  gerealiseerd: number;
  pending: number;
  pending_aantal: number;
  mislukt_aantal: number;
}

export interface Afrekening {
  id: string;
  nummer: string;
  verzamelfactuur: string;
  factuurdatum: string;
  periode: string;
  opdrachtgever: string;
  pool: string | null;
  netto: number;
  btw_bedrag: number;
  btw_behandeling: BtwBehandeling;
  incl_btw: number;
  status: 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';
  uitbetaald_op: string | null;
}

export const KOR_OMZETGRENS = 20000;

export async function getBtwStatus(): Promise<BtwInstellingen> {
  return (await api.get(`${BASIS}/btw-status`)).data.data;
}

export async function zetBtwStatus(invoer: { kor_actief: boolean; kor_sinds?: string | null; rollen: Record<string, RolStatus> }): Promise<BtwInstellingen> {
  return (await api.put(`${BASIS}/btw-status`, invoer)).data.data;
}

export async function getWallet(): Promise<Wallet> {
  return (await api.get(`${BASIS}/wallet`)).data.data;
}

export async function getAfrekeningen(): Promise<Afrekening[]> {
  return (await api.get(`${BASIS}/afrekeningen`)).data.data;
}

export async function openStripeDashboard(): Promise<string> {
  return (await api.post('/professional/stripe/dashboard-link')).data.data.dashboard_url;
}

export async function startStripeOnboarding(): Promise<string> {
  return (await api.post('/professional/stripe/onboarding-link')).data.data.onboarding_url;
}

export async function downloadAfrekening(a: Afrekening, formaat: 'pdf' | 'csv'): Promise<void> {
  const r = await api.get(`${BASIS}/afrekeningen/${a.id}/${formaat}`, { responseType: 'blob' });
  const blob = r.data as Blob;
  const url = URL.createObjectURL(blob.type ? blob : new Blob([blob], { type: formaat === 'pdf' ? 'application/pdf' : 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${a.nummer}.${formaat}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
